import React from "react";
import { useNavigate } from "react-router-dom";

// Componenets
import Typography from "../../../../common/components/Typography";
import Button from "../../../../common/components/Button";

// Mui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const ContentBlock = ({
    title,
    subheader,
    description,
    actionButtonTitle,
    onActionBtnClick,
    levels,
    onLevelHover,
    activeIndex,
}) => {
    const navigate = useNavigate();
    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
                minHeight: { xs: "auto", md: "650px" },
                padding: { xs: "50px 4%", md: "4%", lg: "3%", xl: "2%" },
                boxSizing: "border-box",
            }}
        >
            <Box sx={{ maxWidth: "550px" }}>
                <Typography variant="h3" mb>
                    {title}
                </Typography>
                <Typography variant="h2" mb>
                    {subheader}
                </Typography>
                <Typography variant="paragraph" mb>
                    {description}
                </Typography>

                {actionButtonTitle && (
                    <Button variant="outlined" onClick={onActionBtnClick}>
                        {actionButtonTitle}
                    </Button>
                )}
                {levels && levels.length > 0 && (
                    <Grid container spacing={1}>
                        {levels.map((level, index) => (
                            <Grid item xs={12} md={6}>
                                <Button
                                    key={index}
                                    variant={
                                        activeIndex === index
                                            ? "contained"
                                            : "outlined"
                                    }
                                    endIcon={<ChevronRightIcon />}
                                    onClick={() => navigate(level.url)}
                                    onMouseEnter={() => onLevelHover(index)}
                                    sx={{ whiteSpace: "nowrap" }}
                                    active={activeIndex === index}
                                    fullWidth
                                >
                                    {level.title}
                                </Button>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Box>
        </Stack>
    );
};

export default ContentBlock;
